<div class="ee-history" *ngIf="hasEngagement">
  <div class="ee-history__header">
    <div class="ee-history__title">
      <i class="app-ico-mask app-ico-mask__bolt"></i>
      {{ 'VacanciesMatch.EmailEngagementHistory.Title' | translate }}
    </div>
  </div>

  <div class="ee-history__summary">
    <div class="ee-history__stat">
      <div class="ee-history__stat-label">{{ 'VacanciesMatch.EmailEngagementHistory.CurrentStatus' | translate }}</div>
      <div class="ee-history__stat-value">
        <span class="ee-history__status" [ngClass]="statusClass">
          {{ statusLabelKey | translate }}
        </span>
      </div>
    </div>
    <div class="ee-history__stat">
      <div class="ee-history__stat-label">{{ 'VacanciesMatch.EmailEngagementHistory.Opened' | translate }}</div>
      <div class="ee-history__stat-value">
        <span class="ee-history__opened" [class.is-yes]="isOpened">
          {{ (isOpened ? 'VacanciesMatch.EmailEngagementHistory.OpenedYes' : 'VacanciesMatch.EmailEngagementHistory.OpenedNo') | translate }}
        </span>
      </div>
    </div>
    <div class="ee-history__stat">
      <div class="ee-history__stat-label">{{ 'VacanciesMatch.EmailEngagementHistory.LastUpdated' | translate }}</div>
      <div class="ee-history__stat-value">
        <span class="ee-history__time">{{ lastUpdated || '—' }}</span>
      </div>
    </div>
  </div>

  <div class="ee-history__timeline">
    <div class="ee-history__history-title">
      {{ 'VacanciesMatch.EmailEngagementHistory.History' | translate }}
    </div>
    <div
      class="ee-history__email"
      *ngFor="let email of timelineEmails; trackBy: trackByEmail">
      <div class="ee-history__email-label" *ngIf="email.messageType">
        {{ email.messageType }} {{ 'VacanciesMatch.EmailEngagementHistory.StatusSent' | translate }}
      </div>
      <div class="ee-history__events">
        <div
          class="ee-history__event"
          *ngFor="let event of email.events; trackBy: trackByEvent">
          <span class="ee-history__icon" [ngClass]="event.statusClass">
            <i class="app-ico-mask" [ngClass]="event.iconClass"></i>
          </span>
          <div class="ee-history__event-body">
            <div class="ee-history__event-name">{{ event.labelKey | translate }}</div>
            <div class="ee-history__event-reason" *ngIf="event.reason">{{ event.reason }}</div>
            <div class="ee-history__event-time" *ngIf="event.time">{{ event.time }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
